import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAsyncEffect from 'use-async-effect';
import { getCasinoGamesPage } from 'services/api/gameApiService';
import { filterGamesByProviders } from 'helpers/gameHelper';
import { CasinoGame } from 'types/CasinoGame';
import { RailArrows } from './RailArrows';
import styles from './TopGames.module.css';

/** As many as the casino lobby's own "Top games" row. */
const RAIL = 12;

/** Modern home: the casino's top games; a tap opens the game in the casino. */
export const TopGames = ({ desktop = false }: { desktop?: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [games, setGames] = useState<CasinoGame[]>([]);
  const rail = useRef<HTMLDivElement>(null);

  useAsyncEffect(async (isMounted) => {
    try {
      const first = await getCasinoGamesPage(1, true);
      if (!isMounted()) return;
      // The lobby's order: by provider, as the casino page lists them.
      const all = filterGamesByProviders(first.items).flatMap((p) => p.games);
      setGames(all.slice(0, RAIL));
    } catch {
      // No casino row when the games cannot be loaded.
    }
  }, []);

  if (games.length === 0) return null;

  return (
    <>
      <div
        className={
          desktop ? `${styles.head} ${styles.headDesktop}` : styles.head
        }
      >
        <h2>{t('casino_top_games')}</h2>
        <div className={styles.headEnd}>
          <button type="button" onClick={() => navigate('/casino-games')}>
            {t('modern_show_more')} ›
          </button>
          {desktop && <RailArrows rail={rail} />}
        </div>
      </div>
      <div
        className={
          desktop ? `${styles.rail} ${styles.railDesktop}` : styles.rail
        }
        ref={rail}
      >
        {games.map((g) => (
          <button
            type="button"
            key={g.uuid}
            className={styles.game}
            onClick={() =>
              navigate(`/casino-games?play=${encodeURIComponent(g.uuid)}`)
            }
          >
            <img src={g.image} alt="" />
            <span>{g.name}</span>
          </button>
        ))}
      </div>
    </>
  );
};
